/* global $, sgData, SGAction, shopSettings */
import TaggedLogger from './debug/tagged-logger';
import CSSBugLogger from './web-logging/css-bug-logger';
import ClientInformation from '../app/client-information/ClientInformation';

$(() => {
  const isApp = sgData && sgData.device && sgData.device.access === 'App';
  let ClientInfo;
  if (isApp) {
    ClientInfo = new ClientInformation();
  }
  const debug = new TaggedLogger('CSS-Fail-Watchdog', 'color: orange');

  /**
   * Logs to console
   * @param {string} msg - Text message
   * @param {*} addOn - Additional information
   */
  const log = (msg, addOn = null) => {
    debug.info(msg, addOn);
  };

  /**
   * Check stylesheet load and logs to backend
   * @returns {boolean}
   */
  const cssWatchDog = () => {
    if (
      typeof sgData !== 'undefined'
      && sgData.page
      && sgData.page.name
      && sgData.page.name === 'checkoutSuccess'
    ) {
      log('Page is checkoutSuccess. Aborting to prevent false positive.');
      return false;
    }
    const apiLogger = new CSSBugLogger();
    let cssLoadingWatch = null;

    /**
     * Tries to repair the css, checks if loaded, then logs the result.
     *
     * @param {HtmlElement} el - Style tag
     * @param {string} href - URL of style tag
     */
    const tryToRepair = (el, href) => {
      el.href = '';
      let intervalCount = 0;
      clearInterval(cssLoadingWatch);

      cssLoadingWatch = setInterval(() => {
        try {
          intervalCount += 1;

          if (intervalCount > 5000) {
            clearInterval(cssLoadingWatch);
            log('Try to repair takes too long. Aborting');
            apiLogger.sendLog(
              CSSBugLogger.constants.LEVEL_ERROR,
              {
                msg: 'CssFailWatchdog: Try to repair takes too long. Aborting',
              }
            );
            return;
          }
          let loaded = false;
          try {
            loaded = CSSBugLogger.checkIfCssLoaded(el);
          } catch (e) {
            log('checkIfCssLoaded error', e);
            apiLogger.sendLog(
              CSSBugLogger.constants.LEVEL_ERROR,
              {
                msg: 'checkIfCssLoaded error',
                error: e.message,
              }
            );
          }

          if (loaded) {
            clearInterval(cssLoadingWatch);
            log('New css loaded, sending pageSizeDidChange');
            apiLogger.sendLog(
              CSSBugLogger.constants.LEVEL_ERROR,
              {
                msg: 'CssFailWatchdog: New css loaded, sending pageSizeDidChange',
                iteration: intervalCount,
              }
            );

            if (
              SGAction.hasOwnProperty('pageSizeDidChange')
              && typeof SGAction.pageSizeDidChange === 'function'
            ) {
              SGAction.pageSizeDidChange();
            }

            CSSBugLogger.checkCSS(
              (info) => {
                log('Fixed!');
                apiLogger.sendLog(
                  apiLogger.constructor.constants.LEVEL_INFO,
                  {
                    msg: 'CssFailWatchdog: CSS looks to be fixed',
                    should: info.desiredStyle,
                    is: info.styles.fontFamily,
                    elementExists: info.styleElExists,
                    elementHref: info.href,
                  }
                );
              },
              (info) => {
                log('CSS still looks to be not applied. Sending log.', info);
                apiLogger.sendLog(
                  apiLogger.constructor.constants.LEVEL_ERROR,
                  {
                    msg: 'CssFailWatchdog: No CSS detected, phase 2, aborting',
                    should: info.desiredStyle,
                    is: info.styles.fontFamily,
                    elementExists: info.styleElExists,
                    elementHref: info.href,
                  }
                );
              }
            );
            return;
          }
          log('New css not yet loaded. Will try again');
        } catch (err) {
          // In case, something went wrong
          clearInterval(cssLoadingWatch);
          log('tryToRepair error', err.message);
          apiLogger.sendLog(
            CSSBugLogger.constants.LEVEL_ERROR,
            {
              msg: 'CssFailWatchdog: CSS tryToRepair error',
              error: err.message,
            }
          );
        }
      }, 100);

      setTimeout(() => {
        el.href = href;
      }, 0);
    };

    /**
     * Main logic here.
     */
    try {
      /**
       * Checks if CSS is applied. If not, sends log and executes tryToRepair.
       */
      CSSBugLogger.checkCSS(
        () => {
          log('CSS looks fine.');
        },
        (info) => {
          log('CSS looks to be not applied. Sending log.', info);
          apiLogger.sendLog(
            apiLogger.constructor.constants.LEVEL_ERROR,
            {
              msg: 'CssFailWatchdog: No CSS detected',
              should: info.desiredStyle,
              is: info.styles.fontFamily,
              elementExists: info.styleElExists,
              elementHref: info.href,
            }
          );
          if (info.styleElExists) {
            log('Trying to repair');
            tryToRepair(info.styleEl, info.href);
          } else {
            log('No CSS el found, not trying to repair.');
          }
        }
      );
    } catch (err) {
      // In case, something went wrong
      log('Errored!', err);
      apiLogger.sendLog(
        apiLogger.constructor.constants.LEVEL_ERROR,
        {
          msg: 'CssFailWatchdog: error main',
          error: err.message,
        }
      );
    }
    return true;
  };

  if (ClientInfo) {
    ClientInfo.isCssCheckSupported().then(() => {
      cssWatchDog();
    }).catch(() => {
      log('Not Supported');
    });
  } else {
    cssWatchDog();
  }
});



// WEBPACK FOOTER //
// ./Library/1.0/common/css-fail-watchdog.js